<template>
  <PlatformNavbar
    :is-not-share-page="isNotSharePage"
    :search-term="searchTerm"
    @tracking-event="handleTrackingEvent($event)"
    @update:search="handleSearch"
  />
</template>

<script>
import PlatformNavbar from '@/components/navbar/PlatformNavbar.vue';
import { mapState, mapActions } from 'pinia';
import { useAppPlatform } from '@/stores/app/platform';
import { useTracking } from '@/stores/tracking/tracking';
import { useEditor } from '@/stores/editor/editor';
import { shareableInsights } from '@/helpers/constants/shareableInsights';
import { useFilters } from '@/stores/filters/filters';
import { useSubMenu } from '@/stores/filters/subMenu';

export default {
  name: 'PlatformNavbarContainer',
  components: { PlatformNavbar },
  computed: {
    ...mapState(useEditor, ['isSharePage']),

    ...mapState(useFilters, ['searchTerm']),
    ...mapState(useAppPlatform, {
      platformInitialized: (store) => store.platformInitialized,
    }),
    isReportingSharePage() {
      return shareableInsights.includes(this.$route.name)
        && window.sessionStorage.reportingShareKey;
    },
    isNotSharePage() {
      return !(this.isSharePage || window.sessionStorage.shareKey || this.isReportingSharePage);
    },
    routeJobId() {
      return this.$route.path.split('/')[1] === 'view' && this.$route.params.id;
    },
  },
  watch: {
    $route() {
      this.setPlatformCurrentJobId(this.routeJobId);
    },
    '$route.name': {
      handler() {
        if (!this.platformInitialized && !this.isReportingSharePage) {
          this.initPlatform(this.routeJobId, {
            setInitFieldsAction: (payload) => this.setInitFields(payload),
          });
        }
      },
    },
  },
  created() {
    if (!this.isReportingSharePage) {
      this.initPlatform(this.routeJobId, {
        setInitFieldsAction: (payload) => this.setInitFields(payload),
      });
    }
  },
  methods: {
    ...mapActions(useSubMenu, ['setSelectedSubMenuOption']),
    ...mapActions(useFilters, ['submitSearchTerm']),
    ...mapActions(useAppPlatform, [
      'setPlatformCurrentJobId',
      'initPlatform',
    ]),
    ...mapActions(useEditor, ['setInitFields']),
    handleTrackingEvent({ action, args }) {
      useTracking()[action](args);
    },
    handleSearch(value) {
      if (![
        'published',
        'unpublished',
        'flagship',
        'draft',
        'email',
        'draft-requisitions',
        'open-requisitions',
        'closed-requisitions',
      ].includes(this.$route.name)) {
        this.$router.push({ name: 'published', query: { q: value } });
        this.setSelectedSubMenuOption('relevance');
      } else {
        const dateSort = this.$route.name === 'open-requisitions' ? '-opened_at' : '-closed_at';
        const defaultSort = this.$route.name.includes('requisitions') ? dateSort : 'relevance';

        this.submitSearchTerm({ searchTerm: value, router: this.$router, defaultSort });
      }
    },
  },
};
</script>
